<template>
  <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';

export default {
  name: 'CShanxianButtonShare',
  components: {
    [button.name]: button,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-button-share-',
    };
  },
  computed: {
    computedStyle() {
      return {
        backgroundImage: `url(${this.configurationData.backgroundImg})`,
        backgroundSize: '100% 100%',
      };
    },
  },
  mounted() {
    console.log('configurationData=', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
      this.$refs.button.setClickHandler(this.doShare, {
        forceApp: true,
        forceLogin: true,
      });
      if (this.$isInEditor || !this.$ast.isAPP()) return;
    },
    async initShare() {
      const { userInfo } = this;
      let url = await this.$astSparkPlugin.getShareUrl({
        userInfo,
        type: 'help',
        url: this.shareConfig.link,
      });
      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      url = common.tool.passThroughUrlParam(url, ['via', 'trace_id', 'via_source'], true);
      await this.$ast.setAPPShare({
        title: this.shareConfig.title,
        summary: this.shareConfig.desc,
        targetUrl: url,
        thumbUrl: this.shareConfig.icon,
        callback: this.callback,
      });
    },
    async doShare() {
      console.log('doShare');
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '02', '06');
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '13');
      await this.initShare();
      this.$ast.goAPPShare().then((res) => {
        console.log('button share callback', res);
      });
    },
    async callback(res) {
      const map = {
        WXSession: '14',
        WXTimeline: '15',
        QQFriend: '16',
        QQZone: '17',
      };
      const val = map[res.data.type];
      console.log(val);
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', map[res.data.type]);
      // 分享后的流程
      if (this.configurationData.shareflowId) {
        const response = await this.flowRequest({ flowId: this.configurationData.shareflowId });
        if (!response.ret || !response.data.ret) { // 如果执行成功,上报
          this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '06', '35');
        }
        this.refreshQua();
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
